import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'
import $currency from 'currency.js'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompanyName',
    fieldName: '公司名称',
    option: [],
    url: 'customerCompany/page',
    selectType: 2,
    label: 'mark'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '业务品牌',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '业务名称',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'serial',
    fieldName: '序列号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'marketCost',
    fieldName: '市场成本',
    textAlign: 'right',
    isMoney: true,
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outCost',
    fieldName: '外包成本',
    textAlign: 'right',
    isMoney: true,
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'unit',
    fieldName: '单位',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee2',
    fieldName: '单价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { orderTaxRate } = rowData
      return priceWithoutRate(orderFee, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee3',
    fieldName: '总价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { amount, orderTaxRate } = rowData
      return totalPriceWithoutRate(orderFee, amount, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee4',
    fieldName: '总价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { amount } = rowData
      return numberTimes(orderFee, amount, true)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderTaxRate',
    fieldName: '税率',
    formatType: 'percent',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'title',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesManName',
    fieldName: '业务代表',
    option: [],
    selectType: 2,
    label: 'mark',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '业务状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceStatus',
    fieldName: '开票状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'receivedStatus',
    fieldName: '收款状态',
    width: 100
  },
  {
    componentType: 'el-array',
    componentName: '输入框',
    fieldKey: 'invoiceInfo',
    fieldName: '发票号码',
    formatValue: (data) => {
      const { details } = data
      return details ? details.map((kk: any) => kk.no).join('，') : ''
    }
  },
  {
    componentType: 'el-array',
    componentName: '输入框',
    fieldKey: 'invoiceDate',
    fieldName: '发票日期',
    formatValue: (data) => {
      const { details } = data
      return details ? details.map((kk: any) => kk.date).join('，') : ''
    }
  },
  {
    componentType: 'el-array',
    componentName: '输入框',
    fieldKey: 'invoicePrice',
    fieldName: '发票金额',
    width: 100,
    formatValue: (data) => {
      const { details } = data
      return details ? details.map((kk: any) => $currency(kk.amount)).join('，') : ''
    }
  }
]
